import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import Home from './pages/Home';
import Services from './pages/Services';
import Contact from './pages/Contact';
import GDPR from './pages/GDPR';
import About from './pages/About';
import Priser from './pages/Priser';
import Blog from './pages/Blog';
import Foredrag from './pages/Foredrag';
import YouTube from './pages/YouTube';
import Nyhedsbrev from './pages/Nyhedsbrev';
import OekonomiskRaadgivning from './pages/OekonomiskRaadgivning';
import OekonomiOverblik from './pages/OekonomiOverblik';
import Pensionsraadgivning from './pages/Pensionsraadgivning';
import BoligRaadgivning from './pages/BoligRaadgivning';
import Investering from './pages/Investering';
import Erhvervsraadgivning from './pages/Erhvervsraadgivning';
import Investeringsraadgivning from './pages/Investeringsraadgivning';
import BlogPost from './pages/BlogPost';

function App() {
  return (
    <HelmetProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          
          {/* Privat section */}
          <Route path="/oekonomisk-raadgivning" element={<OekonomiskRaadgivning />} />
          <Route path="/oekonomi-overblik" element={<OekonomiOverblik />} />
          <Route path="/pensionsraadgivning" element={<Pensionsraadgivning />} />
          <Route path="/bolig-raadgivning" element={<BoligRaadgivning />} />
          <Route path="/investering" element={<Investering />} />
          
          {/* Erhverv section */}
          <Route path="/erhvervsraadgivning" element={<Erhvervsraadgivning />} />
          <Route path="/investeringsraadgivning" element={<Investeringsraadgivning />} />
          
          {/* Main menu items */}
          <Route path="/foredrag" element={<Foredrag />} />
          <Route path="/priser" element={<Priser />} />
          <Route path="/youtube" element={<YouTube />} />
          <Route path="/nyhedsbrev" element={<Nyhedsbrev />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/kontakt-os" element={<Contact />} />
          <Route path="/gdpr" element={<GDPR />} />
          
          {/* Dynamic Blog Route */}
          <Route path="/:slug" element={<BlogPost />} />
        </Routes>
      </Layout>
    </HelmetProvider>
  );
}

export default App;
